import { create } from 'zustand';
import { Deal } from '../types/deal';

interface DealStore {
  deals: Deal[];
  setDeals: (deals: Deal[]) => void;
  addDeal: (deal: Deal) => void;
  updateDeal: (id: string, updatedDeal: Deal) => void;
  deleteDeal: (id: string) => void;
}

export const useDealStore = create<DealStore>((set) => ({
  deals: [],
  setDeals: (deals) => set({ deals }),
  addDeal: (deal) => set((state) => ({ deals: [...state.deals, deal] })),
  updateDeal: (id, updatedDeal) =>
    set((state) => ({
      deals: state.deals.map((deal) => (deal.id === id ? updatedDeal : deal)),
    })),
  deleteDeal: (id) =>
    set((state) => ({
      deals: state.deals.filter((deal) => deal.id !== id),
    })),
})); 
